/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegexpQueryValue
 */
export interface RegexpQueryValue {
    /**
     * Regular expression pattern.
     * @type {string}
     * @memberof RegexpQueryValue
     */
    value: string;
    /**
     * Regex flags (only 'i' for case-insensitive supported).
     * @type {string}
     * @memberof RegexpQueryValue
     */
    flags?: RegexpQueryValueFlagsEnum;
}


/**
 * @export
 */
export const RegexpQueryValueFlagsEnum = {
    I: 'i'
} as const;
export type RegexpQueryValueFlagsEnum = typeof RegexpQueryValueFlagsEnum[keyof typeof RegexpQueryValueFlagsEnum];


/**
 * Check if a given object implements the RegexpQueryValue interface.
 */
export function instanceOfRegexpQueryValue(value: object): value is RegexpQueryValue {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function RegexpQueryValueFromJSON(json: any): RegexpQueryValue {
    return RegexpQueryValueFromJSONTyped(json, false);
}

export function RegexpQueryValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegexpQueryValue {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'flags': json['flags'] == null ? undefined : json['flags'],
    };
}

export function RegexpQueryValueToJSON(json: any): RegexpQueryValue {
    return RegexpQueryValueToJSONTyped(json, false);
}

export function RegexpQueryValueToJSONTyped(value?: RegexpQueryValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'flags': value['flags'],
    };
}

